import React, { createContext, useState } from "react";
import { Toast } from "../components/common/Toast";
import CustomerGroupService from "../services/CustomerGroupService";

export const CustomerGroupContext = createContext("CustomerGroupContext");

const CustomerGroupContextProvider = ({ children }) => {
	const [customerGroupList, setCustomerGroupList] = useState([]);
	const [loadingCustomerGroupList, setLoadingCustomerGroupList] =
		useState(false);
	const [customerGroupListErrorMsg, setCustomerGroupListErrorMsg] =
		useState("");
	const [totalElements, setTotalElements] = useState(0);

	const getCustomerGroupList = async (params) => {
		setLoadingCustomerGroupList(true);
		setCustomerGroupListErrorMsg("");
		try {
			const response =
				await CustomerGroupService.getCustomerGroupList(params);
			setCustomerGroupList(response.data.content);
			setTotalElements(response.data.totalElements);
		} catch (error) {
			const message = error.response
				? error.response.data.message
					? error.response.data.message
					: error.response.data
				: error.message;
			setCustomerGroupListErrorMsg(message);
			Toast("error", "Error", message);
		} finally {
			setLoadingCustomerGroupList(false);
		}
	};

	return (
		<CustomerGroupContext.Provider
			value={{
				getCustomerGroupList,
				customerGroupList,
				totalElements,
				loadingCustomerGroupList,
				customerGroupListErrorMsg,
			}}
		>
			{children}
		</CustomerGroupContext.Provider>
	);
};

export default CustomerGroupContextProvider;
